import type {
	Program,
	ProgramIssueCaughtPhase,
} from '../../../interfaces/CamProgramming.interface';

/** The two phases an embedded reviewer can log issues against. */
export type ReviewPhase = Extract<
	ProgramIssueCaughtPhase,
	'review' | 'secondary_review'
>;

/** The review rollup the phase is derived from. */
type ReviewRollup = Pick<Program, 'first_review_id' | 'first_reviewer'>;

export const REVIEW_PHASE_LABEL: Record<ReviewPhase, string> = {
	review: 'Review',
	secondary_review: 'Secondary Review',
};

/**
 * Which review the signed-in user is here to log against.
 *
 * Nobody performs a second review of their own work, so the phase follows from
 * who logged the first review: that person stays on it, and anybody else
 * becomes the secondary reviewer. Nothing is left for the user to choose.
 *
 * A first review whose reviewer account is gone still counts as someone
 * else's, so the next person through is the secondary reviewer.
 */
export function reviewPhaseFor(
	program: ReviewRollup,
	currentUserId: string
): ReviewPhase {
	if (!program.first_review_id) {
		return 'review';
	}

	return program.first_reviewer?.id === currentUserId
		? 'review'
		: 'secondary_review';
}
